var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-wrapper",class:[_vm.color, { disabled: _vm.disabled }]},[_c('div',{staticClass:"shadow"}),_c('k-btn',_vm._g(_vm._b({staticClass:"tw-flex-auto tw-whitespace-no-wrap",class:_vm.customClass,attrs:{"disabled":_vm.disabled,"color":_vm.color}},'k-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }